import { getApiUrl } from "./tcApiUrl";
export function getLandedCostURL() {
  const classifyurl = `${getApiUrl("landedCostCalculator")}`;
  return classifyurl;
}

export const getLandedCostURLValue = () => {
  return getLandedCostURL();
};
